import React, { Children, PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './NavigationBar.scss';

export default class UtilityNavigation extends PureComponent {
	static propTypes = {
		children: PropTypes.node.isRequired
	};

	render() {
		const { children } = this.props;

		return (
			<nav className={styles.utilityNavigation}>
				<ul>
					{Children.map(children, child => (
						<li>{child}</li>
					))}
				</ul>
			</nav>
		);
	}
}
